// snackbarSlice.js
import { createSlice } from '@reduxjs/toolkit';

let nextId = 0;

const initialState = {
  queue: [],
};

const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    showSnackbar: (state, action) => {
      const snackbar = {
        id: nextId++,
        message: action.payload.message,
        severity: action.payload.severity || 'success',
        response: action.payload.response || null,
        count: 1
      };
      let index = state.queue.findIndex((s) => s.message === snackbar.message && s.severity === snackbar.severity && s.response === snackbar.response)
      if (index !== -1)
      {
        state.queue[index].count += 1
      } else {
        state.queue.push(snackbar);
      }
    },
    hideSnackbar: (state, action) => {
      // Remove the snackbar with the given ID
      state.queue = state.queue.filter(snackbar => snackbar.id !== action.payload);
    },
  },
});

export const { showSnackbar, hideSnackbar } = snackbarSlice.actions;

export default snackbarSlice.reducer;